import React,{useState} from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import {Row,Col} from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionssession } from '../../Helper'
import Purplebutton from '../desktop/subComponent/Purplebutton'
import { validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
const PreOUpdateMonthlyStuTeaCompmb = () => {
    const [mainpagesearch, setmainpagesearch] = useState("")
    const [period,setperiod] = useState("")
    const [perioderr,setperioderr] = useState("")
    const [periodlabel,setperiodlabel] = useState("")
    const [id,setid]=useState("")
   
    const [name,setname]= useState("")
   
    const [totalsubalready,settotalsubalready] = useState("")
   
    const [totalsubalreadyupdate,settotalsubalreadyupdate] = useState("")

    const handlemainpagesearch = (e) => {
            setmainpagesearch(e.target.value)
        }
        const drpfuncperiod = (myval, myid) => {
            setperiod(myval)
        }
        const handleid=(e)=>{
            setid(e.target.value)
        }

        const handleUpdate=()=>{
            validationDrp(period,setperiodlabel,setperioderr,"Period Required")
            console.log("hello man")
        }
    return (
        <>
            <div className="felxvaluecompmbmain">
                <div className="studentdashboardmobilewrapper">
                    <div className="mobilecontainer">
                        <div className="adminmbheading">
                            <h3>Student Attendance Process</h3>
                        </div>
                        <div className="admbwrap">
                        <Row style={{marginTop:"20px"}}> 
                        <Col xs={6} className="pr5" >
                            <div className="basicinput">
                                <p>Search Student ID</p>
                                <div className="wrap">
                                    <input type="text"  placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch} />
                                    <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} className="pr5 pl5" >
                        <div className="basicinput">
                            <p>Periods</p>
                            <div className="inputgap ">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={perioderr === "err" ? "err" : ""} func={drpfuncperiod} myplaceholder="Select" fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                </div>
                                <label>{periodlabel}</label>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} className="pr5 pl5" >
                            <div className="basicinput">
                                <p>ID</p>
                                <div className="wrap">
                                    <input type="text" placeholder="" value={id} onChange={handleid} disabled/>
                            
                                </div>
                            </div>
                        </Col>
                    <Col xs={6} className="pr5 pl5" >
                            <div className="basicinput">
                                <p>Name</p>
                                <div className="wrap">
                                    <input type="text" placeholder="" value={name} disabled onChange={(e)=>setname(e.target.value)} />  
                                                               
                                </div>
                            </div>
                        </Col>
                    <Col xs={6} className="pr5 pl5" >
                            <div className="basicinput">
                                <p>Total Subject Already Setup</p>
                                <div className="wrap">
                                    <input disabled type="text" placeholder="" value={totalsubalready} onChange={(e)=>settotalsubalready(e.target.value)} />   
                                                            
                                </div>
                            </div>
                        </Col>
                    <Col xs={6} className="pl5">
                            <div className="basicinput">
                                <p>Total Subject After Update</p>
                                <div className="wrap">
                                    <input disabled type="text" placeholder="" value={totalsubalreadyupdate} onChange={(e)=>settotalsubalreadyupdate(e.target.value)} /> 
                                                                
                                </div>
                            </div>
                        </Col>
                        <Col lg={12} className="text-center">
                            <Purplebutton mt="0px" clickfunc={handleUpdate} btnname="Update" w="120px" h="40px" ></Purplebutton>
                        </Col>
                    </Row>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PreOUpdateMonthlyStuTeaCompmb